import KyMethod from "./KyMethod"

export default class ProgramRepositories extends KyMethod {
  async getRawPrograms() {
    return this._getStrapiProtectedData("/programs?populate=*")
  }
}
